'use client';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Fragment } from 'react';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { Box } from '../box/box.component.js';
import { Link } from '../link/link.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';
import { FlexBox } from '../flex-box/flex-box.component.js';
import { VisuallyHidden } from '../visually-hidden/visually-hidden.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, n = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), n.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t.push.apply(t, n);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, n, o = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(n = 0; n < s.length; n++)t = s[n], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
    }
    return o;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, n, o = {}, s = Object.keys(e);
    for(n = 0; n < s.length; n++)t = s[n], r.indexOf(t) >= 0 || (o[t] = e[t]);
    return o;
}
const RatingsStars = renderWithRef('RatingsStars', null, (s, u)=>{
    var { skin: f = 'standard', ratingValue: m = 0, hideRating: b = false, reviews: d, href: g, 'aria-label': y, accessibleTextForReviewCount: w } = s, O = _object_without_properties(s, [
        "skin",
        "ratingValue",
        "hideRating",
        "reviews",
        "href",
        'aria-label',
        "accessibleTextForReviewCount"
    ]);
    useComponentStylesLoaded('RatingsStars', SWAN_STYLE_KEY_MAP.ratingsStars);
    let [j, h] = m.toFixed(1).split('.').map((e)=>Number(e)), _ = [
        'swan-ratings'
    ];
    return 'standard' !== f && _.push(`swan-ratings-skin-${f}`), jsx(RenderComp, {
        root: "div",
        props: O,
        forwardedRef: u,
        classNames: _,
        children: jsxs(FlexBox, {
            className: "swan-ratings-stars-container",
            flexWrap: "wrap",
            alignItems: "center",
            gap: 2,
            children: [
                jsx(Box, {
                    className: "swan-ratings-stars",
                    role: "img",
                    "aria-label": y,
                    children: Array.from({
                        length: 5
                    }).map((r, t)=>{
                        let n = [
                            'swan-ratings-star'
                        ];
                        return t + 1 <= j && n.push('swan-ratings-star-filled'), (h && t + 1) === j + 1 && n.push(`swan-ratings-star-filled-p${h}`), jsx("span", {
                            className: n.join(' ')
                        }, `star_${t}`);
                    })
                }),
                !b && jsx("span", {
                    className: "swan-ratings-stars-rating",
                    "aria-hidden": y ? 'true' : 'false',
                    children: m
                }),
                null != d && jsxs("span", {
                    className: "swan-ratings-stars-reviews",
                    children: [
                        "(",
                        jsxs(g ? Link : Fragment, _object_spread_props(_object_spread({}, g ? {
                            to: g
                        } : {}), {
                            children: [
                                jsx("span", {
                                    "aria-hidden": w ? 'true' : 'false',
                                    children: d
                                }),
                                w && jsx(VisuallyHidden, {
                                    children: w
                                })
                            ]
                        })),
                        ")"
                    ]
                })
            ]
        })
    });
});

export { RatingsStars };
